import { useEffect, useState } from 'react'

enum ScrollDirection {
  DOWN,
  UPSIDE,
}

export function useScroll() {
  const [scrollDir, setScrollDir] = useState(ScrollDirection.UPSIDE)
  const [scroll, setScroll] = useState(0)
  const [isHeaderHidden, setIsHeaderHidden] = useState(false)

  const isScrollingUp = scrollDir === ScrollDirection.UPSIDE
  const hideHeader = isHeaderHidden

  const toggleHeaderVisibility = (value: boolean) => {
    setIsHeaderHidden(value)
  }

  useEffect(() => {
    const threshold = 80
    let lastScrollY = window.scrollY
    let ticking = false

    const updateScrollDir = () => {
      const scrollY = window.scrollY
      const isScrollingDown = scrollY > lastScrollY
      const belowThreshold = Math.abs(scrollY - lastScrollY) < threshold

      setScroll(scrollY)

      if (isScrollingDown && belowThreshold) {
        ticking = false
        return
      }

      if (lastScrollY && (!belowThreshold || !isScrollingDown)) {
        setScrollDir(
          isScrollingDown ? ScrollDirection.DOWN : ScrollDirection.UPSIDE,
        )
      }
      else {
        setScrollDir(ScrollDirection.UPSIDE)
      }

      lastScrollY = Math.max(0, scrollY)
      ticking = false
    }

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollDir)
        ticking = true
      }
    }

    window.addEventListener('scroll', onScroll)

    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return { isScrollingUp, scroll, hideHeader, toggleHeaderVisibility }
}
